import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    removeAll: translate({ id: 'order.form.bulk.timeWindows.removeAll' }),
    title: translate({ id: 'order.form.bulk.timeWindows.mixed.alert.title' }),
    description: translate({ id: 'order.form.bulk.timeWindows.mixed.alert.description' }),
    deleteAllTimeWindowsDisabledTooltip: translate({
      id: 'order.form.bulk.timeWindows.deleteAllTimeWindowsDisabledTooltip',
    }),
  }))

  return api
}
